import { JSX, useState } from 'react';
import { TodoTask } from '../todolist/add-todo/addTodoList';
import NoteTodoView from './note-todo-view';
import { NoteProps } from '../note/note';
import './note-todos.css';

interface NoteTodosProps {
    note: NoteProps
    todos: TodoTask[];
    editTitle: (todo: TodoTask, newTitle: string) => void;
    deleteTodo: (todo: TodoTask) => void;
    saveTodo: (todo: TodoTask) => void;
}

const NoteTodos = ( { note, todos, editTitle, deleteTodo, saveTodo }: NoteTodosProps ) : JSX.Element => {

    const [addNewTodo, setAddNewTodo] = useState(false);
    const [newTodo, setNewTodo] = useState<TodoTask>({
        id: Date.now(),
        title: "",
        completed: false,
        category: 'Work',
        date: note.date,
        content: "",
        noteId: note.id,
    });

    const editTodo = (todo: TodoTask, title: string) => {
        setNewTodo({...newTodo, title: title});
    }

    const cancelAddTodo = () => {
        setNewTodo({...newTodo, 
            id: Date.now(),
            title: '',
            completed: false,
            category: 'Work',
            date: note.date,
            content: "",
            noteId: note.id,
        });
        setAddNewTodo(false);
    }

    const addTodo = () => {
        saveTodo(newTodo);
        cancelAddTodo();
    }

    return (
        <div>
            {todos && todos.map(todo => (
                <NoteTodoView 
                    key={todo.id}
                    todo={todo}
                    editTitle={(newTitle) => editTitle(todo, newTitle)}
                    deleteTodo={() => deleteTodo(todo)}
                    newTodo={false}
                    saveTodo={()=>{}}
                />
            ))}
            {addNewTodo? 
                (<NoteTodoView
                key={newTodo.id}
                todo={newTodo}
                editTitle={(newTitle) => editTodo(newTodo, newTitle)}
                deleteTodo={() => cancelAddTodo}
                newTodo={true}
                saveTodo={addTodo}
                />) : <></>
            }
            <p className='add-todo-button' onClick={()=> setAddNewTodo(true)}>+</p>
        </div>
    );
};

export default NoteTodos;